import { post, get, destroy, download, API_ENDPOINT } from '@/helpers/api'

export default {
    ROUTE_NAME (context, routeName) {
        context.commit('SET_CURRENT_ROUTE', routeName)
    },

    LOGIN (context, credentials) {
        return new Promise( (resolve, reject) => {
            post(API_ENDPOINT + 'auth/user-login', credentials) 
                .then(response => {
                    context.commit('SET_USER', response.data)
                    context.dispatch('MAP_ITEMS')
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
  
    LOGOUT (context) {
        return new Promise( (resolve, reject) => {
            get(API_ENDPOINT + 'auth/logout')
            .then(response => {
                context.commit('SET_USER', null)
                context.commit('SET_MAP_ITEMS', null)
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },
  
    PASSWORD_RESET_REQUEST (context, email) {
        return new Promise( (resolve, reject) => {
            post(API_ENDPOINT + 'password/create', email)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    PASSWORD_RESET (context, credentials) {
        return new Promise( (resolve, reject) => {
            post(API_ENDPOINT + 'password/reset', credentials)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    PASSWORD_RESET_TOKEN_FIND(context, token) {
        return new Promise( (resolve, reject) => {
            get(API_ENDPOINT + 'password/find/' + token)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },
  
    MAP_ITEMS (context) {
        context.commit('SET_LOADER', true)
        context.commit('SET_LOADER_TEXT', "Pridobivanje podatkov je v teku...")
        return new Promise( (resolve, reject) => {
            get(API_ENDPOINT + 'promet-bohinj/map-items')
            .then(response => {
                //window.console.log("MAP_ITEMS")
                //window.console.log(response.data.data)
                context.commit('SET_MAP_ITEMS', response.data.data)
                resolve(response)
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    // Ujemi 401 napako (npr. seja je potekla)
                    context.dispatch('LOGOUT');
                    // Lahko sprožiš logout, redirect ali prikažeš obvestilo
                    // context.dispatch('LOGOUT') ali podobno
                }
                reject(error)
            })
            .finally(() => {
                setTimeout(() => {
                    context.commit('SET_LOADER', false)
                    context.commit('SET_LOADER_TEXT', "")
                }, 500)
            })
        })
    },

    UPDATE_MAP_ITEM_CAMPING (context, payload) {
        return new Promise( (resolve, reject) => {
            post(API_ENDPOINT + 'promet-bohinj/map-items/camping/' + payload.id + "/update", payload)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },


    UPDATE_MAP_ITEM_PARKING (context, payload) {
        return new Promise( (resolve, reject) => {
            post(API_ENDPOINT + 'promet-bohinj/map-items/parking/' + payload.id + "/update", payload)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    GET_SETTINGS(context) {
        return new Promise( (resolve, reject) => {
            get(API_ENDPOINT + 'promet-bohinj/settings')
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    SAVE_SETTINGS(context, data) {
        return new Promise((resolve, reject) => {
            post(API_ENDPOINT + 'promet-bohinj/settings/save', data)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    DOWNLOAD_FILE(context, uuid) {
        return new Promise( (resolve, reject) => {
            download(API_ENDPOINT + 'promet-bohinj/exports/'+ uuid + '/download')
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    DELETE_FILE(context, uuid) {
        return new Promise( (resolve, reject) => {
            get(API_ENDPOINT + 'promet-bohinj/exports/'+ uuid + '/delete')
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    DEVICE_STATUS(context, data) {
        return new Promise((resolve, reject) => {
            post(API_ENDPOINT + 'services/parking-gates/status', data)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    DEVICE_IDENTIFICATION(context, data) {
        context.commit('SET_RPI_DATA', data)
    },

    SETUP_RPI_DATA(context) {
        context.commit('RPI_DATA')
    }
    


}